
const searchInput =
  document.querySelector(
    ".search-input"
  );

const searchDropdown =
  document.querySelector(
    ".search-results-dropdown"
  );

async function fetchSearchResults(query) {

  if (query.length < 2) {

    searchDropdown.classList.remove(
      "active"
    );

    searchDropdown.innerHTML = "";

    return;
  }

  const response = await fetch(
    `/search/suggest?q=${query}&resources[type]=product&section_id=predictive-search`
  );

  const text =
    await response.text();

  const html =
    new DOMParser().parseFromString(
      text,
      "text/html"
    );

  const results =
    html.querySelector(
      "#predictive-search-results"
    );

  if (results &&
      results.innerHTML.trim() !== "") {


const loadingSpinner =
  results.querySelector(
    ".predictive-search__loading-state"
  );

if (loadingSpinner) {
  loadingSpinner.remove();
}

searchDropdown.innerHTML =
  results.innerHTML;


    searchDropdown.classList.add(
      "active"
    );

  } else {

    searchDropdown.classList.remove(
      "active"
    );

  }
}

searchInput.addEventListener(
  "input",
  (e) => {

    fetchSearchResults(
      e.target.value
    );

  }
);

document.addEventListener(
  "click",
  (e) => {

    if (
      !e.target.closest(
        ".search-bar-wrapper"
      )
    ) {

      searchDropdown.classList.remove(
        "active"
      );

    }

  }
);